/* tslint:disable */
/* eslint-disable */
/**
 * Reckon Bolt API
 * Backend API for Reckon Bolt
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
    import type {
        AgentVariableDistribution200ResponseInner,
        SoloQRoundSummaries,
        SoloQRoundSummariesAggregate,
    } from '../models/index';

            export interface SoloQRoundSummariesAggregateRequest {
                groupby: Array<string>;
                ordering: Array<string>;
                account?: number;
                additional_filters?: object;
                agent?: string;
                aggregates?: Array<string>;
                attack_pattern_full?: string;
                attack_pattern_short?: string;
                bomb_site?: string;
                callout_15s?: string;
                competitive_player?: string;
                date?: string;
                defense_pattern_full?: string;
                defense_pattern_short?: string;
                first_attack_site?: string;
                freeze_time_end_timestamp?: number;
                game_id?: string;
                having?: object;
                index_on?: string;
                map?: string;
                metrics?: Array<string>;
                patch?: string;
                plant_time?: number;
                puuid?: string;
                rank_tier?: SoloQRoundSummariesAggregateRankTierEnum;
                round_eco_type?: string;
                round_eco_type_no_bonus?: string;
                round_id?: string;
                round_index?: number;
                shield?: string;
                side?: string;
                start_time_seconds?: number;
                team?: SoloQRoundSummariesAggregateTeamEnum;
            }

            export interface SoloQRoundSummariesFieldValuesRequest {
                field: string;
                ordering: Array<string>;
                account?: number;
                additional_filters?: object;
                agent?: string;
                attack_pattern_full?: string;
                attack_pattern_short?: string;
                bomb_site?: string;
                callout_15s?: string;
                competitive_player?: string;
                date?: string;
                defense_pattern_full?: string;
                defense_pattern_short?: string;
                first_attack_site?: string;
                freeze_time_end_timestamp?: number;
                game_id?: string;
                map?: string;
                patch?: string;
                plant_time?: number;
                puuid?: string;
                rank_tier?: SoloQRoundSummariesFieldValuesRankTierEnum;
                round_eco_type?: string;
                round_eco_type_no_bonus?: string;
                round_id?: string;
                round_index?: number;
                shield?: string;
                side?: string;
                start_time_seconds?: number;
                team?: SoloQRoundSummariesFieldValuesTeamEnum;
            }

            export interface SoloQRoundSummariesGetRequest {
                id: string;
            }

            export interface SoloQRoundSummariesListRequest {
                account?: number;
                additional_filters?: object;
                agent?: string;
                annotations?: Array<string>;
                attack_pattern_full?: string;
                attack_pattern_short?: string;
                bomb_site?: string;
                callout_15s?: string;
                competitive_player?: string;
                date?: string;
                defense_pattern_full?: string;
                defense_pattern_short?: string;
                first_attack_site?: string;
                freeze_time_end_timestamp?: number;
                game_id?: string;
                map?: string;
                only_values?: Array<string>;
                ordering?: Array<string>;
                patch?: string;
                plant_time?: number;
                puuid?: string;
                rank_tier?: SoloQRoundSummariesListRankTierEnum;
                round_eco_type?: string;
                round_eco_type_no_bonus?: string;
                round_id?: string;
                round_index?: number;
                shield?: string;
                side?: string;
                start_time_seconds?: number;
                team?: SoloQRoundSummariesListTeamEnum;
            }

            export interface SoloQRoundSummariesVariableDistributionRequest {
                bucket_size: number;
                max: number;
                metric: string;
                min: number;
                account?: number;
                additional_filters?: object;
                agent?: string;
                attack_pattern_full?: string;
                attack_pattern_short?: string;
                bomb_site?: string;
                callout_15s?: string;
                competitive_player?: string;
                date?: string;
                defense_pattern_full?: string;
                defense_pattern_short?: string;
                first_attack_site?: string;
                freeze_time_end_timestamp?: number;
                game_id?: string;
                map?: string;
                patch?: string;
                plant_time?: number;
                puuid?: string;
                rank_tier?: SoloQRoundSummariesVariableDistributionRankTierEnum;
                round_eco_type?: string;
                round_eco_type_no_bonus?: string;
                round_id?: string;
                round_index?: number;
                shield?: string;
                side?: string;
                start_time_seconds?: number;
                team?: SoloQRoundSummariesVariableDistributionTeamEnum;
            }

        /**
        * 
        */
            export class SoloQRoundSummariesApi extends runtime.BaseAPI {

            /**
            */
            async soloQRoundSummariesAggregateRaw(requestParameters: SoloQRoundSummariesAggregateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SoloQRoundSummariesAggregate>>> {
                    if (requestParameters.groupby === null || requestParameters.groupby === undefined) {
                    throw new runtime.RequiredError('groupby','Required parameter requestParameters.groupby was null or undefined when calling soloQRoundSummariesAggregate.');
                    }

                    if (requestParameters.ordering === null || requestParameters.ordering === undefined) {
                    throw new runtime.RequiredError('ordering','Required parameter requestParameters.ordering was null or undefined when calling soloQRoundSummariesAggregate.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.account !== undefined) {
                            queryParameters['account'] = requestParameters.account;
                    }

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.agent !== undefined) {
                            queryParameters['agent'] = requestParameters.agent;
                    }

                    if (requestParameters.aggregates) {
                        queryParameters['aggregates'] = requestParameters.aggregates;
                    }

                    if (requestParameters.attack_pattern_full !== undefined) {
                            queryParameters['attack_pattern_full'] = requestParameters.attack_pattern_full;
                    }

                    if (requestParameters.attack_pattern_short !== undefined) {
                            queryParameters['attack_pattern_short'] = requestParameters.attack_pattern_short;
                    }

                    if (requestParameters.bomb_site !== undefined) {
                            queryParameters['bomb_site'] = requestParameters.bomb_site;
                    }

                    if (requestParameters.callout_15s !== undefined) {
                            queryParameters['callout_15s'] = requestParameters.callout_15s;
                    }

                    if (requestParameters.competitive_player !== undefined) {
                            queryParameters['competitive_player'] = requestParameters.competitive_player;
                    }

                    if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date;
                    }

                    if (requestParameters.defense_pattern_full !== undefined) {
                            queryParameters['defense_pattern_full'] = requestParameters.defense_pattern_full;
                    }

                    if (requestParameters.defense_pattern_short !== undefined) {
                            queryParameters['defense_pattern_short'] = requestParameters.defense_pattern_short;
                    }

                    if (requestParameters.first_attack_site !== undefined) {
                            queryParameters['first_attack_site'] = requestParameters.first_attack_site;
                    }

                    if (requestParameters.freeze_time_end_timestamp !== undefined) {
                            queryParameters['freeze_time_end_timestamp'] = requestParameters.freeze_time_end_timestamp;
                    }

                    if (requestParameters.game_id !== undefined) {
                            queryParameters['game_id'] = requestParameters.game_id;
                    }

                    if (requestParameters.groupby) {
                        queryParameters['groupby'] = requestParameters.groupby;
                    }

                    if (requestParameters.having !== undefined) {
                            queryParameters['having'] = requestParameters.having;
                    }

                    if (requestParameters.index_on !== undefined) {
                            queryParameters['index_on'] = requestParameters.index_on;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.metrics) {
                        queryParameters['metrics'] = requestParameters.metrics;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.patch !== undefined) {
                            queryParameters['patch'] = requestParameters.patch;
                    }

                    if (requestParameters.plant_time !== undefined) {
                            queryParameters['plant_time'] = requestParameters.plant_time;
                    }

                    if (requestParameters.puuid !== undefined) {
                            queryParameters['puuid'] = requestParameters.puuid;
                    }

                    if (requestParameters.rank_tier !== undefined) {
                            queryParameters['rank_tier'] = requestParameters.rank_tier;
                    }

                    if (requestParameters.round_eco_type !== undefined) {
                            queryParameters['round_eco_type'] = requestParameters.round_eco_type;
                    }

                    if (requestParameters.round_eco_type_no_bonus !== undefined) {
                            queryParameters['round_eco_type_no_bonus'] = requestParameters.round_eco_type_no_bonus;
                    }

                    if (requestParameters.round_id !== undefined) {
                            queryParameters['round_id'] = requestParameters.round_id;
                    }

                    if (requestParameters.round_index !== undefined) {
                            queryParameters['round_index'] = requestParameters.round_index;
                    }

                    if (requestParameters.shield !== undefined) {
                            queryParameters['shield'] = requestParameters.shield;
                    }

                    if (requestParameters.side !== undefined) {
                            queryParameters['side'] = requestParameters.side;
                    }

                    if (requestParameters.start_time_seconds !== undefined) {
                            queryParameters['start_time_seconds'] = requestParameters.start_time_seconds;
                    }

                    if (requestParameters.team !== undefined) {
                            queryParameters['team'] = requestParameters.team;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/SoloQRoundSummaries/operations/aggregate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async aggregate(requestParameters: SoloQRoundSummariesAggregateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SoloQRoundSummariesAggregate>> {
                    const response = await this.soloQRoundSummariesAggregateRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async soloQRoundSummariesFieldValuesRaw(requestParameters: SoloQRoundSummariesFieldValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
                    if (requestParameters.field === null || requestParameters.field === undefined) {
                    throw new runtime.RequiredError('field','Required parameter requestParameters.field was null or undefined when calling soloQRoundSummariesFieldValues.');
                    }

                    if (requestParameters.ordering === null || requestParameters.ordering === undefined) {
                    throw new runtime.RequiredError('ordering','Required parameter requestParameters.ordering was null or undefined when calling soloQRoundSummariesFieldValues.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.account !== undefined) {
                            queryParameters['account'] = requestParameters.account;
                    }

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.agent !== undefined) {
                            queryParameters['agent'] = requestParameters.agent;
                    }

                    if (requestParameters.attack_pattern_full !== undefined) {
                            queryParameters['attack_pattern_full'] = requestParameters.attack_pattern_full;
                    }

                    if (requestParameters.attack_pattern_short !== undefined) {
                            queryParameters['attack_pattern_short'] = requestParameters.attack_pattern_short;
                    }

                    if (requestParameters.bomb_site !== undefined) {
                            queryParameters['bomb_site'] = requestParameters.bomb_site;
                    }

                    if (requestParameters.callout_15s !== undefined) {
                            queryParameters['callout_15s'] = requestParameters.callout_15s;
                    }

                    if (requestParameters.competitive_player !== undefined) {
                            queryParameters['competitive_player'] = requestParameters.competitive_player;
                    }

                    if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date;
                    }

                    if (requestParameters.defense_pattern_full !== undefined) {
                            queryParameters['defense_pattern_full'] = requestParameters.defense_pattern_full;
                    }

                    if (requestParameters.defense_pattern_short !== undefined) {
                            queryParameters['defense_pattern_short'] = requestParameters.defense_pattern_short;
                    }

                    if (requestParameters.field !== undefined) {
                            queryParameters['field'] = requestParameters.field;
                    }

                    if (requestParameters.first_attack_site !== undefined) {
                            queryParameters['first_attack_site'] = requestParameters.first_attack_site;
                    }

                    if (requestParameters.freeze_time_end_timestamp !== undefined) {
                            queryParameters['freeze_time_end_timestamp'] = requestParameters.freeze_time_end_timestamp;
                    }

                    if (requestParameters.game_id !== undefined) {
                            queryParameters['game_id'] = requestParameters.game_id;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.patch !== undefined) {
                            queryParameters['patch'] = requestParameters.patch;
                    }

                    if (requestParameters.plant_time !== undefined) {
                            queryParameters['plant_time'] = requestParameters.plant_time;
                    }

                    if (requestParameters.puuid !== undefined) {
                            queryParameters['puuid'] = requestParameters.puuid;
                    }

                    if (requestParameters.rank_tier !== undefined) {
                            queryParameters['rank_tier'] = requestParameters.rank_tier;
                    }

                    if (requestParameters.round_eco_type !== undefined) {
                            queryParameters['round_eco_type'] = requestParameters.round_eco_type;
                    }

                    if (requestParameters.round_eco_type_no_bonus !== undefined) {
                            queryParameters['round_eco_type_no_bonus'] = requestParameters.round_eco_type_no_bonus;
                    }

                    if (requestParameters.round_id !== undefined) {
                            queryParameters['round_id'] = requestParameters.round_id;
                    }

                    if (requestParameters.round_index !== undefined) {
                            queryParameters['round_index'] = requestParameters.round_index;
                    }

                    if (requestParameters.shield !== undefined) {
                            queryParameters['shield'] = requestParameters.shield;
                    }

                    if (requestParameters.side !== undefined) {
                            queryParameters['side'] = requestParameters.side;
                    }

                    if (requestParameters.start_time_seconds !== undefined) {
                            queryParameters['start_time_seconds'] = requestParameters.start_time_seconds;
                    }

                    if (requestParameters.team !== undefined) {
                            queryParameters['team'] = requestParameters.team;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/SoloQRoundSummaries/operations/field-values`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse<any>(response);
            }

            /**
            */
                async field_values(requestParameters: SoloQRoundSummariesFieldValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
                    const response = await this.soloQRoundSummariesFieldValuesRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async soloQRoundSummariesGetRaw(requestParameters: SoloQRoundSummariesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SoloQRoundSummaries>> {
                    if (requestParameters.id === null || requestParameters.id === undefined) {
                    throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling soloQRoundSummariesGet.');
                    }

            const queryParameters: any = {};

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/SoloQRoundSummaries/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                                return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async get(requestParameters: SoloQRoundSummariesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SoloQRoundSummaries> {
                    const response = await this.soloQRoundSummariesGetRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async soloQRoundSummariesListRaw(requestParameters: SoloQRoundSummariesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SoloQRoundSummaries>>> {
            const queryParameters: any = {};

                    if (requestParameters.account !== undefined) {
                            queryParameters['account'] = requestParameters.account;
                    }

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.agent !== undefined) {
                            queryParameters['agent'] = requestParameters.agent;
                    }

                    if (requestParameters.annotations) {
                        queryParameters['annotations'] = requestParameters.annotations;
                    }

                    if (requestParameters.attack_pattern_full !== undefined) {
                            queryParameters['attack_pattern_full'] = requestParameters.attack_pattern_full;
                    }

                    if (requestParameters.attack_pattern_short !== undefined) {
                            queryParameters['attack_pattern_short'] = requestParameters.attack_pattern_short;
                    }

                    if (requestParameters.bomb_site !== undefined) {
                            queryParameters['bomb_site'] = requestParameters.bomb_site;
                    }

                    if (requestParameters.callout_15s !== undefined) {
                            queryParameters['callout_15s'] = requestParameters.callout_15s;
                    }

                    if (requestParameters.competitive_player !== undefined) {
                            queryParameters['competitive_player'] = requestParameters.competitive_player;
                    }

                    if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date;
                    }

                    if (requestParameters.defense_pattern_full !== undefined) {
                            queryParameters['defense_pattern_full'] = requestParameters.defense_pattern_full;
                    }

                    if (requestParameters.defense_pattern_short !== undefined) {
                            queryParameters['defense_pattern_short'] = requestParameters.defense_pattern_short;
                    }

                    if (requestParameters.first_attack_site !== undefined) {
                            queryParameters['first_attack_site'] = requestParameters.first_attack_site;
                    }

                    if (requestParameters.freeze_time_end_timestamp !== undefined) {
                            queryParameters['freeze_time_end_timestamp'] = requestParameters.freeze_time_end_timestamp;
                    }

                    if (requestParameters.game_id !== undefined) {
                            queryParameters['game_id'] = requestParameters.game_id;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.only_values) {
                        queryParameters['only_values'] = requestParameters.only_values;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.patch !== undefined) {
                            queryParameters['patch'] = requestParameters.patch;
                    }

                    if (requestParameters.plant_time !== undefined) {
                            queryParameters['plant_time'] = requestParameters.plant_time;
                    }

                    if (requestParameters.puuid !== undefined) {
                            queryParameters['puuid'] = requestParameters.puuid;
                    }

                    if (requestParameters.rank_tier !== undefined) {
                            queryParameters['rank_tier'] = requestParameters.rank_tier;
                    }

                    if (requestParameters.round_eco_type !== undefined) {
                            queryParameters['round_eco_type'] = requestParameters.round_eco_type;
                    }

                    if (requestParameters.round_eco_type_no_bonus !== undefined) {
                            queryParameters['round_eco_type_no_bonus'] = requestParameters.round_eco_type_no_bonus;
                    }

                    if (requestParameters.round_id !== undefined) {
                            queryParameters['round_id'] = requestParameters.round_id;
                    }

                    if (requestParameters.round_index !== undefined) {
                            queryParameters['round_index'] = requestParameters.round_index;
                    }

                    if (requestParameters.shield !== undefined) {
                            queryParameters['shield'] = requestParameters.shield;
                    }

                    if (requestParameters.side !== undefined) {
                            queryParameters['side'] = requestParameters.side;
                    }

                    if (requestParameters.start_time_seconds !== undefined) {
                            queryParameters['start_time_seconds'] = requestParameters.start_time_seconds;
                    }

                    if (requestParameters.team !== undefined) {
                            queryParameters['team'] = requestParameters.team;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/SoloQRoundSummaries/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async list(requestParameters: SoloQRoundSummariesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SoloQRoundSummaries>> {
                    const response = await this.soloQRoundSummariesListRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async soloQRoundSummariesVariableDistributionRaw(requestParameters: SoloQRoundSummariesVariableDistributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AgentVariableDistribution200ResponseInner>>> {
                    if (requestParameters.bucket_size === null || requestParameters.bucket_size === undefined) {
                    throw new runtime.RequiredError('bucket_size','Required parameter requestParameters.bucket_size was null or undefined when calling soloQRoundSummariesVariableDistribution.');
                    }

                    if (requestParameters.max === null || requestParameters.max === undefined) {
                    throw new runtime.RequiredError('max','Required parameter requestParameters.max was null or undefined when calling soloQRoundSummariesVariableDistribution.');
                    }

                    if (requestParameters.metric === null || requestParameters.metric === undefined) {
                    throw new runtime.RequiredError('metric','Required parameter requestParameters.metric was null or undefined when calling soloQRoundSummariesVariableDistribution.');
                    }

                    if (requestParameters.min === null || requestParameters.min === undefined) {
                    throw new runtime.RequiredError('min','Required parameter requestParameters.min was null or undefined when calling soloQRoundSummariesVariableDistribution.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.account !== undefined) {
                            queryParameters['account'] = requestParameters.account;
                    }

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.agent !== undefined) {
                            queryParameters['agent'] = requestParameters.agent;
                    }

                    if (requestParameters.attack_pattern_full !== undefined) {
                            queryParameters['attack_pattern_full'] = requestParameters.attack_pattern_full;
                    }

                    if (requestParameters.attack_pattern_short !== undefined) {
                            queryParameters['attack_pattern_short'] = requestParameters.attack_pattern_short;
                    }

                    if (requestParameters.bomb_site !== undefined) {
                            queryParameters['bomb_site'] = requestParameters.bomb_site;
                    }

                    if (requestParameters.bucket_size !== undefined) {
                            queryParameters['bucket_size'] = requestParameters.bucket_size;
                    }

                    if (requestParameters.callout_15s !== undefined) {
                            queryParameters['callout_15s'] = requestParameters.callout_15s;
                    }

                    if (requestParameters.competitive_player !== undefined) {
                            queryParameters['competitive_player'] = requestParameters.competitive_player;
                    }

                    if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date;
                    }

                    if (requestParameters.defense_pattern_full !== undefined) {
                            queryParameters['defense_pattern_full'] = requestParameters.defense_pattern_full;
                    }

                    if (requestParameters.defense_pattern_short !== undefined) {
                            queryParameters['defense_pattern_short'] = requestParameters.defense_pattern_short;
                    }

                    if (requestParameters.first_attack_site !== undefined) {
                            queryParameters['first_attack_site'] = requestParameters.first_attack_site;
                    }

                    if (requestParameters.freeze_time_end_timestamp !== undefined) {
                            queryParameters['freeze_time_end_timestamp'] = requestParameters.freeze_time_end_timestamp;
                    }

                    if (requestParameters.game_id !== undefined) {
                            queryParameters['game_id'] = requestParameters.game_id;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.max !== undefined) {
                            queryParameters['max'] = requestParameters.max;
                    }

                    if (requestParameters.metric !== undefined) {
                            queryParameters['metric'] = requestParameters.metric;
                    }

                    if (requestParameters.min !== undefined) {
                            queryParameters['min'] = requestParameters.min;
                    }

                    if (requestParameters.patch !== undefined) {
                            queryParameters['patch'] = requestParameters.patch;
                    }

                    if (requestParameters.plant_time !== undefined) {
                            queryParameters['plant_time'] = requestParameters.plant_time;
                    }

                    if (requestParameters.puuid !== undefined) {
                            queryParameters['puuid'] = requestParameters.puuid;
                    }

                    if (requestParameters.rank_tier !== undefined) {
                            queryParameters['rank_tier'] = requestParameters.rank_tier;
                    }

                    if (requestParameters.round_eco_type !== undefined) {
                            queryParameters['round_eco_type'] = requestParameters.round_eco_type;
                    }

                    if (requestParameters.round_eco_type_no_bonus !== undefined) {
                            queryParameters['round_eco_type_no_bonus'] = requestParameters.round_eco_type_no_bonus;
                    }

                    if (requestParameters.round_id !== undefined) {
                            queryParameters['round_id'] = requestParameters.round_id;
                    }

                    if (requestParameters.round_index !== undefined) {
                            queryParameters['round_index'] = requestParameters.round_index;
                    }

                    if (requestParameters.shield !== undefined) {
                            queryParameters['shield'] = requestParameters.shield;
                    }

                    if (requestParameters.side !== undefined) {
                            queryParameters['side'] = requestParameters.side;
                    }

                    if (requestParameters.start_time_seconds !== undefined) {
                            queryParameters['start_time_seconds'] = requestParameters.start_time_seconds;
                    }

                    if (requestParameters.team !== undefined) {
                            queryParameters['team'] = requestParameters.team;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/SoloQRoundSummaries/operations/variable-distribution`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async variable_distribution(requestParameters: SoloQRoundSummariesVariableDistributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AgentVariableDistribution200ResponseInner>> {
                    const response = await this.soloQRoundSummariesVariableDistributionRaw(requestParameters, initOverrides);
                    return await response.value();
                }

        }

                            /**
                            * @export
                            */
                            export const SoloQRoundSummariesAggregateRankTierEnum = {
                                NUMBER_0: 0,
                                NUMBER_1: 1,
                                NUMBER_10: 10,
                                NUMBER_11: 11,
                                NUMBER_12: 12,
                                NUMBER_13: 13,
                                NUMBER_14: 14,
                                NUMBER_15: 15,
                                NUMBER_16: 16,
                                NUMBER_17: 17,
                                NUMBER_18: 18,
                                NUMBER_19: 19,
                                NUMBER_2: 2,
                                NUMBER_20: 20,
                                NUMBER_21: 21,
                                NUMBER_22: 22,
                                NUMBER_23: 23,
                                NUMBER_24: 24,
                                NUMBER_25: 25,
                                NUMBER_26: 26,
                                NUMBER_27: 27,
                                NUMBER_3: 3,
                                NUMBER_4: 4,
                                NUMBER_5: 5,
                                NUMBER_6: 6,
                                NUMBER_7: 7,
                                NUMBER_8: 8,
                                NUMBER_9: 9
                            } as const;
                            export type SoloQRoundSummariesAggregateRankTierEnum = typeof SoloQRoundSummariesAggregateRankTierEnum[keyof typeof SoloQRoundSummariesAggregateRankTierEnum];
                            /**
                            * @export
                            */
                            export const SoloQRoundSummariesAggregateTeamEnum = {
                                NUMBER_1: 1,
                                NUMBER_2: 2
                            } as const;
                            export type SoloQRoundSummariesAggregateTeamEnum = typeof SoloQRoundSummariesAggregateTeamEnum[keyof typeof SoloQRoundSummariesAggregateTeamEnum];
                            /**
                            * @export
                            */
                            export const SoloQRoundSummariesFieldValuesRankTierEnum = {
                                NUMBER_0: 0,
                                NUMBER_1: 1,
                                NUMBER_10: 10,
                                NUMBER_11: 11,
                                NUMBER_12: 12,
                                NUMBER_13: 13,
                                NUMBER_14: 14,
                                NUMBER_15: 15,
                                NUMBER_16: 16,
                                NUMBER_17: 17,
                                NUMBER_18: 18,
                                NUMBER_19: 19,
                                NUMBER_2: 2,
                                NUMBER_20: 20,
                                NUMBER_21: 21,
                                NUMBER_22: 22,
                                NUMBER_23: 23,
                                NUMBER_24: 24,
                                NUMBER_25: 25,
                                NUMBER_26: 26,
                                NUMBER_27: 27,
                                NUMBER_3: 3,
                                NUMBER_4: 4,
                                NUMBER_5: 5,
                                NUMBER_6: 6,
                                NUMBER_7: 7,
                                NUMBER_8: 8,
                                NUMBER_9: 9
                            } as const;
                            export type SoloQRoundSummariesFieldValuesRankTierEnum = typeof SoloQRoundSummariesFieldValuesRankTierEnum[keyof typeof SoloQRoundSummariesFieldValuesRankTierEnum];
                            /**
                            * @export
                            */
                            export const SoloQRoundSummariesFieldValuesTeamEnum = {
                                NUMBER_1: 1,
                                NUMBER_2: 2
                            } as const;
                            export type SoloQRoundSummariesFieldValuesTeamEnum = typeof SoloQRoundSummariesFieldValuesTeamEnum[keyof typeof SoloQRoundSummariesFieldValuesTeamEnum];
                            /**
                            * @export
                            */
                            export const SoloQRoundSummariesListRankTierEnum = {
                                NUMBER_0: 0,
                                NUMBER_1: 1,
                                NUMBER_10: 10,
                                NUMBER_11: 11,
                                NUMBER_12: 12,
                                NUMBER_13: 13,
                                NUMBER_14: 14,
                                NUMBER_15: 15,
                                NUMBER_16: 16,
                                NUMBER_17: 17,
                                NUMBER_18: 18,
                                NUMBER_19: 19,
                                NUMBER_2: 2,
                                NUMBER_20: 20,
                                NUMBER_21: 21,
                                NUMBER_22: 22,
                                NUMBER_23: 23,
                                NUMBER_24: 24,
                                NUMBER_25: 25,
                                NUMBER_26: 26,
                                NUMBER_27: 27,
                                NUMBER_3: 3,
                                NUMBER_4: 4,
                                NUMBER_5: 5,
                                NUMBER_6: 6,
                                NUMBER_7: 7,
                                NUMBER_8: 8,
                                NUMBER_9: 9
                            } as const;
                            export type SoloQRoundSummariesListRankTierEnum = typeof SoloQRoundSummariesListRankTierEnum[keyof typeof SoloQRoundSummariesListRankTierEnum];
                            /**
                            * @export
                            */
                            export const SoloQRoundSummariesListTeamEnum = {
                                NUMBER_1: 1,
                                NUMBER_2: 2
                            } as const;
                            export type SoloQRoundSummariesListTeamEnum = typeof SoloQRoundSummariesListTeamEnum[keyof typeof SoloQRoundSummariesListTeamEnum];
                            /**
                            * @export
                            */
                            export const SoloQRoundSummariesVariableDistributionRankTierEnum = {
                                NUMBER_0: 0,
                                NUMBER_1: 1,
                                NUMBER_10: 10,
                                NUMBER_11: 11,
                                NUMBER_12: 12,
                                NUMBER_13: 13,
                                NUMBER_14: 14,
                                NUMBER_15: 15,
                                NUMBER_16: 16,
                                NUMBER_17: 17,
                                NUMBER_18: 18,
                                NUMBER_19: 19,
                                NUMBER_2: 2,
                                NUMBER_20: 20,
                                NUMBER_21: 21,
                                NUMBER_22: 22,
                                NUMBER_23: 23,
                                NUMBER_24: 24,
                                NUMBER_25: 25,
                                NUMBER_26: 26,
                                NUMBER_27: 27,
                                NUMBER_3: 3,
                                NUMBER_4: 4,
                                NUMBER_5: 5,
                                NUMBER_6: 6,
                                NUMBER_7: 7,
                                NUMBER_8: 8,
                                NUMBER_9: 9
                            } as const;
                            export type SoloQRoundSummariesVariableDistributionRankTierEnum = typeof SoloQRoundSummariesVariableDistributionRankTierEnum[keyof typeof SoloQRoundSummariesVariableDistributionRankTierEnum];
                            /**
                            * @export
                            */
                            export const SoloQRoundSummariesVariableDistributionTeamEnum = {
                                NUMBER_1: 1,
                                NUMBER_2: 2
                            } as const;
                            export type SoloQRoundSummariesVariableDistributionTeamEnum = typeof SoloQRoundSummariesVariableDistributionTeamEnum[keyof typeof SoloQRoundSummariesVariableDistributionTeamEnum];
